import React from "react";
import { Box, Typography } from "@mui/material";
import typography from "../cssUtils/typography";

const StatTile = ({ value, label, valueColor = "#1D2330", sx = {} }) => (
  <Box
    sx={{
      flex: 1,
      minWidth: 120,
      border: "1px solid #E5E7EB",
      borderRadius: "10px",
      backgroundColor: "#fff",
      px: 2,
      py: 1.5,
      ...sx,
    }}
  >
    <Typography sx={{ ...typography.h2, fontWeight: 700, color: valueColor, lineHeight: 1.2 }}>
      {value}
    </Typography>
    <Typography sx={{ ...typography.bodySmall, color: "#6C7C93", mt: 0.25 }}>
      {label}
    </Typography>
  </Box>
);

export default StatTile;
